import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from './components/Home';
import PocketDetails from './components/PocketDetails'; // 将原 App.js 的内容移到这个组件中
import EmailConfirmResult from './components/EmailConfirmResult';
import PasswordReset from './components/PasswordReset';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pocket-details" element={<PocketDetails />} />
        <Route path="/auth/callback" element={<EmailConfirmResult />} />
        <Route path="/auth/password-reset" element={<PasswordReset />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
